module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.photoIdProp != 'abc') ? _c('div', {
    staticClass: "image-wrap"
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "src": _vm.photoComp,
      "crossOrigin": "Anonymous"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "close",
    on: {
      "click": function($event) {
        _vm.deleteImage()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash",
    attrs: {
      "title": "Delete this photo"
    }
  })])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-82fc3d00!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PetRegistration/components/PetPicView.vue
// module id = 646
// module chunks = 2